import React, { useContext, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { FocusOn } from 'react-focus-on'

const PrivacyModal = ({
  action = false,
  children,
  closeButtonLabel,
  closeOnBackgroundClick,
  id = '',
  isOpen = false,
  onBackButtonClick,
  onClose,
  overpanel = false,
  style = {},
}) => {
  const worldReady = useContext(WorldReadyContext)
  const modalRef = useRef()

  const setFixedHeight = () => {
    const fixedHeight = window.innerHeight

    const modalEl = modalRef.current

    if (modalEl) {
      if (overpanel) {
        modalEl.style.height = ''.concat(fixedHeight, 'px')
      } else {
        modalEl.style.maxHeight = ''.concat(fixedHeight, 'px')
      }
    }
  }

  const handleEscape = function (evt) {
    evt.preventDefault()
    onClose(evt)
  }

  const handleBackdropClick = function (evt) {
    if (closeOnBackgroundClick) {
      onClose(evt)
    }
  }

  const handleClose = function (evt) {
    evt.preventDefault()
    onClose(evt)
  }

  const handleBack = function (evt) {
    evt.preventDefault()
    onBackButtonClick(evt)
  }

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints

    if (isTouchDevice && window.innerHeight) {
      setFixedHeight()
      window.addEventListener('resize', setFixedHeight, false)
    }

    return () => {
      window.removeEventListener('resize', setFixedHeight)
    }
  }, [])

  return ReactDOM.createPortal(
    <div
      className={`ppvx_modal-backdrop ${
        isOpen ? 'ppvx_modal-backdrop--show' : ''
      }`}
      id="pnw-modal"
      role="dialog"
      aria-modal="true"
      aria-hidden={isOpen ? 'false' : 'true'}
      data-ppvx_modal-background-close={closeOnBackgroundClick}
      ref={modalRef}
      data-testid="pnw-modal"
    >
      <FocusOn
        enabled={!!isOpen}
        onClickOutside={handleBackdropClick}
        onEscapeKey={handleEscape}
      >
        <div className="ppvx_modal--container_bottom">
          <article
            id={id}
            className={`ppvx_modal ${overpanel ? 'ppvx_modal--overpanel' : ''}`}
            style={style}
          >
            <header className="ppvx_modal-header pnw_modal-header">
              <div className="ppvx_modal-header__action">
                {action && (
                  <a
                    onClick={handleBack}
                    className="ppvx_icon-button ppvx_icon-button--primary pnw_modal-header__icon-btn"
                    href="/"
                    id="privacyModalBackIconButton"
                    aria-label={new MessageFormat(worldReady, {
                      id: `app.navigation.backLink`,
                    }).format()}
                    data-testid="privacyModalBackIconButton"
                  >
                    <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-arrow-left ppvx_icon-button__icon">
                      <span className="ppvx_icon-button__label">Back</span>
                    </span>
                  </a>
                )}
              </div>
              <div className="ppvx_modal-header__close">
                <button
                  className="ppvx_modal-header__close-btn pnw_modal-header__close-btn"
                  data-action-close-modal="true"
                  id="privacyModalCloseIconButton"
                  aria-label={closeButtonLabel}
                  tabIndex="0"
                  onClick={handleClose}
                  data-testid="privacyModalCloseIconButton"
                />
              </div>
            </header>
            <section className="ppvx_modal__contents pnw_modal-contents privacy-modal-content">
              {children}
            </section>
          </article>
        </div>
      </FocusOn>
    </div>,
    document.body,
  )
}

export default PrivacyModal
